import { useEffect, useRef, useState, useCallback } from 'react';
import Feather from '@sysunite/react-feather';
import { Tooltip, Input, Row, Col, Button, Switch } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import './SearchGraphButton.scss';

const SearchGraphButton = ({ onSearch }) => {

  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState('');
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [showMisses, setShowMisses] = useState(false);
  const inputRef = useRef();

  const iconType = isOpen ? 'x' : 'search';

  const handleOpen = useCallback(() => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  }, []);

  const handleInputChange = useCallback((e) => {
    const { value } = e.target;
    setValue(value);
    onSearch(value, !showMisses);
  }, [showMisses, onSearch]);

  const handlePressEnter = useCallback((e) => {
    const { value } = e.target;
    onSearch(value, !showMisses);
  }, [showMisses, onSearch]);

  const handleTooltipVisibleChange = useCallback((visible) => {
    setIsTooltipVisible(visible);
  }, []);

  const handleSwitchChange = useCallback((checked) => {
    setShowMisses(checked);
  }, []);

  useEffect(() => {
    if (isOpen) {
      inputRef.current?.focus();
    }
    setValue('');
  }, [isOpen]);

  const classNames = ['search-graph', isOpen && 'is-open'].filter(Boolean).join(' ');

  return (
    <Tooltip
      visible={!isOpen && isTooltipVisible}
      placement="bottomLeft"
      trigger="hover"
      onVisibleChange={handleTooltipVisibleChange}
      mouseEnterDelay={1}
      title="Search in the graph"
    >
      <div
        onContextMenu={(e) => e.stopPropagation()}
        className={classNames}
      >
        <Row align="middle">
          <Col>
            <Button onClick={handleOpen} type="link" icon={<Feather size="1.5em" type={iconType} />} />
          </Col>
          <Col style={{ flex: 1 }}>
            <Input
              ref={inputRef}
              value={value}
              onChange={handleInputChange}
              onPressEnter={handlePressEnter}
              placeholder="Search in graph"
            />
          </Col>
          <Col>
            <Switch
              checked={showMisses}
              checkedChildren={<EyeOutlined />}
              unCheckedChildren={<EyeInvisibleOutlined />}
              onChange={handleSwitchChange}
            />
          </Col>
        </Row>
      </div>
    </Tooltip>
  );
};

export default SearchGraphButton;
